import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/about.scss";
import { Link } from "react-router-dom";

function About() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="color-scheme color-scheme--scheme-1">
      <Header />

      <main className="about-page">
        {/* Hero Section with Image */}
        <section className="about-hero">
          <div className="hero-image-container">
            <img
              src="/main/about1.jpg"
              alt="Billy Reid Collection"
              className="hero-image"
            />
          </div>
        </section>

        {/* Title Section */}
        <section className="about-title-section">
          <h1>Bernicemy: A Modern Southern Studio</h1>
        </section>

        {/* Content Grid */}
        <section className="about-content-grid">
          {/* Row 1: Portrait + Suit Detail */}
          <div className="grid-row">
            <div className="grid-item grid-item-large">
              <img
                src="/main/about2-1.jpg"
                alt="Billy Reid Portrait"
                className="grid-image"
              />
            </div>
            <div className="grid-item grid-item-large">
              <img
                src="/main/about2-2.webp"
                alt="Suit Detail"
                className="grid-image"
              />
              <div className="text-overlay">
                <p className="overlay-text">
                  From our home in Florence, Alabama, we bring our sensibility
                  to the world at large through standout clothing, crafted with
                  integrity and authenticity.
                </p>
              </div>
            </div>
          </div>

          {/* Row 2: Hands + Awards Photo */}
          <div className="grid-row">
            <div className="grid-item grid-item-large">
              <img
                src="/main/about3-1.webp"
                alt="Craftsmanship"
                className="grid-image"
              />
            </div>
            <div className="grid-item grid-item-large">
              <img
                src="/main/about3-2.webp"
                alt="CFDA Awards"
                className="grid-image"
              />
              <div className="text-overlay">
                <p className="overlay-text">
                  Over 20 years, we have earned some of the most prestigious
                  honors in fashion, including four CFDA awards.
                </p>
              </div>
            </div>
          </div>

          {/* Row 3: Sweater + Silhouette */}
          <div className="grid-row">
            <div className="grid-item grid-item-large">
              <img
                src="/main/about4-1.webp"
                alt="Knitwear"
                className="grid-image"
              />
            </div>
            <div className="grid-item grid-item-large">
              <img
                src="/main/about4-2.jpg"
                alt="Silhouette"
                className="grid-image"
              />
              <div className="text-overlay">
                <p className="overlay-text">
                  More importantly, we make clothing that is built to last. We
                  believe in creating fewer, better things.
                </p>
              </div>
            </div>
          </div>

          {/* Row 4: Mood Boards */}
          <div className="grid-row grid-row-full">
            <div className="grid-item grid-item-full">
              <img
                src="/main/about5.webp"
                alt="Design Studio"
                className="grid-image"
              />
            </div>
          </div>
        </section>

        {/* Sustainability Quote Section */}
        <section className="about-quote-section">
          <p className="quote-text">
            This approach balances sustainability and artisanship.
          </p>
        </section>

        {/* Design Sketches Section */}
        <section className="about-sketches-section">
          <div className="sketches-content">
            <img
              src="/main/about6.webp"
              alt="Design Sketches"
              className="sketches-image"
            />
            <div className="sketches-text-overlay">
              <p className="sketches-text">
                Take your favorite wardrobe staples and improve them through
                unexpected, high-quality detailing—carefully considering every
                button, every thread, every stitch.
              </p>
            </div>
          </div>
        </section>

        {/* Community Section */}
        <section className="about-community-section">
          <div className="community-grid">
            <div className="community-item">
              <img
                src="/main/about7-1.webp"
                alt="Community Style"
                className="community-image"
              />
              <div className="community-text-overlay">
                <p className="community-text">
                  We believe strongly in community, and draw constant
                  inspiration from the artists, musicians, chefs and makers that
                  surround us. We celebrate that community every year at our
                  Shindig festival.
                </p>
              </div>
            </div>
            <div className="community-item">
              <img
                src="/main/about7-2.webp"
                alt="Shindig Festival"
                className="community-image"
              />
            </div>
          </div>
        </section>

        {/* Welcome Message Section */}
        <section className="about-welcome-section">
          <p className="welcome-text">
            We welcome you into our corner of the world, and we hope you'll
            welcome us and our work into yours — wherever you go.
          </p>
          <button className="playlist-button">
            CHECK OUT OUR CURRENT PLAYLIST
          </button>
        </section>

        {/* Bottom Images Section */}
        <section className="about-bottom-section">
          <div className="bottom-grid">
            <div className="bottom-item">
              <img
                src="/main/about8-1.webp"
                alt="Billy Reid Store"
                className="bottom-image"
              />
              <Link onClick={toTop} to="/shop" className="bottom-link">
                Find a Shop Near You
              </Link>
            </div>
            <div className="bottom-item">
              <img
                src="/main/about8-2.webp"
                alt="Shop Collection"
                className="bottom-image"
              />
              <Link onClick={toTop} to="/shop" className="bottom-link">
                Shop Now
              </Link>
            </div>
            <div className="bottom-item">
              <img
                src="/main/about8-3.webp"
                alt="Follow Us"
                className="bottom-image"
              />
              <Link
                onClick={toTop}
                to="https://www.instagram.com/billyreid"
                className="bottom-link"
              >
                Follow Us on Instagram
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default About;
